import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import SubHeader from '../../components/SubHeader/SubHeader';
import { useTranslation } from 'react-i18next';
import DashBoard from '../../components/DashBoard/DashBoard';
import Button from '../../components/Button/Button';
import styles from './NotificationView.module.scss';
import NotificationLabel from './NotificationLabel/NotificationLabel';
import cn from 'classnames';
import Container from '../../components/Container/Container';
import Line from '../../components/Line/Line';
import DateInput from '../../components/Form/DateInput/DateInput';
import useResponsive from '../../hooks/useResponsive';
import { useAppDispatch, useAppSelector } from '../../store/reducers';
import { filterNotifications, getNotifications, markAsRead } from '../../store/reducers/Notifications/slice';
import Loader from '../../components/Loader/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import Heading from '../../components/Typography/Heading/Heading';
import IconBox from '../../components/IconBox/IconBox';
import { ReactComponent as ArrowTop } from '../../assets/icons/arrow-down.svg';
import Paragraph from '../../components/Typography/Paragraph/Paragraph';
import CancelIcon from '../../components/CancelIcon/CancelIcon';
const NotificationView = () => {
    const { t } = useTranslation();
    const isResponsive = useResponsive('xl');
    const dispatch = useAppDispatch();
    const { userNotifications, limit, isLoading, metaData: { page } } = useAppSelector((state) => state.notifications);
    const { activeWallet: { address, name } } = useAppSelector((state) => state.wallet);
    const [dateData, setDateData] = useState(null);
    const [backButton, setBackButton] = useState(false);
    const [showReset, setShowReset] = useState(false);
    const dataId = userNotifications.map(({ id }) => id);
    const [isoDate, setIsoDate] = useState('');
    const fetchData = useCallback(() => {
        dispatch(getNotifications({ page, limit }));
    }, [page, limit]);
    const fetchNextPage = useCallback(() => {
        const nextPage = page + 1;
        dispatch(getNotifications({ page: nextPage, limit }));
    }, [page, limit]);
    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    useEffect(() => {
        dispatch(getNotifications({ page, limit }));
    }, [address, name, dispatch]);
    //Removing Scroll listener on unmount
    useEffect(() => {
        const scrollListener = () => {
            if (window.scrollY > 100 && userNotifications.length) {
                setBackButton(true);
            }
            else {
                setBackButton(false);
            }
        };
        window.addEventListener('scroll', scrollListener);
        return () => window.removeEventListener('scroll', scrollListener);
    }, [userNotifications]);
    //Filtering Notification Data
    const handleDateFilter = useCallback((data) => {
        const date = data;
        date.setHours(10);
        setDateData(date);
        dispatch(filterNotifications({ date: data.toISOString(), page, limit }));
        setIsoDate(data.toISOString());
        setShowReset(true);
    }, [dispatch, limit]);
    //Removing Reset Button from UI
    const handleDateReset = useCallback(() => {
        setShowReset(false);
        setDateData(null);
        setIsoDate('');
        fetchData();
    }, []);
    const fetchFilteredData = () => {
        dispatch(filterNotifications({ date: isoDate, page, limit }));
    };
    //Reset Button
    const ResetAction = (_jsxs("button", Object.assign({ onClick: handleDateReset, className: cn(styles.resetAction, 'd-flex align-items-center') }, { children: [_jsx(CancelIcon, { className: styles.resetIcon }), _jsx(Paragraph, { className: "", title: "Reset", onClick: () => setShowReset(false) })] })));
    return (_jsxs("div", Object.assign({ className: styles.element }, { children: [!isResponsive && _jsx(SubHeader, { title: t('notifications') }), _jsx("div", Object.assign({ className: cn(styles.box) }, { children: _jsxs(Container, Object.assign({ className: 'd-flex justify-content-end align-items-center' }, { children: [_jsx(Button, { className: styles.markAsRead, size: 'md', color: 2, onClick: () => dispatch(markAsRead(dataId)), text: t('mark_all_as_read') }), showReset && ResetAction, _jsx(DateInput, { placeholder: t('filter_by_date'), dateData: dateData, onChange: handleDateFilter })] })) })), _jsx(Line, {}), _jsxs(DashBoard, Object.assign({ container: false, className: cn(styles.wrapper) }, { children: [_jsx("div", Object.assign({ className: 'd-flex flex-column' }, { children: _jsx(InfiniteScroll, Object.assign({ dataLength: userNotifications.length, next: showReset ? fetchFilteredData : fetchNextPage, hasMore: true, loader: !showReset &&
                                isLoading &&
                                !!userNotifications.length && _jsx(Loader, { className: styles.loader }) }, { children: userNotifications.map((data) => (_jsx(NotificationLabel, { notification: data }, data.id))) })) })), backButton && (_jsx(IconBox, Object.assign({ className: styles.arrowTop, onClick: scrollUp }, { children: _jsx(ArrowTop, {}) }))), !userNotifications.length && !isLoading && (_jsx(Heading, { className: styles.heading, size: 1, title: t('you_have_no_notifications') })), isLoading && _jsx(Loader, { className: styles.heading })] }))] })));
};
export default NotificationView;
